export default __webpack_public_path__ + "static/media/check.31d2b14a.svg";